import _default from './Search';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// /home/gitlab_ci_multi_runner/builds/88e00e75/0/bryx911/ua-download/~/semantic-ui-react/dist/es/modules/Search/index.js
// module id = 826
// module chunks = 0